"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var CloseCircleIcon = function CloseCircleIcon(props) {
  return _react["default"].createElement("svg", (0, _extends2["default"])({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), _react["default"].createElement("path", {
    d: "M14.957,9.043 C15.348,9.434 15.348,10.066 14.957,10.457 L13.414,12 L14.957,13.543 C15.348,13.934 15.348,14.566 14.957,14.957 C14.762,15.152 14.506,15.25 14.25,15.25 C13.994,15.25 13.738,15.152 13.543,14.957 L12,13.414 L10.457,14.957 C10.262,15.152 10.006,15.25 9.75,15.25 C9.494,15.25 9.238,15.152 9.043,14.957 C8.652,14.566 8.652,13.934 9.043,13.543 L10.586,12 L9.043,10.457 C8.652,10.066 8.652,9.434 9.043,9.043 C9.434,8.652 10.066,8.652 10.457,9.043 L12,10.586 L13.543,9.043 C13.934,8.652 14.566,8.652 14.957,9.043 Z M12,20 C16.411,20 20,16.411 20,12 C20,7.589 16.411,4 12,4 C7.589,4 4,7.589 4,12 C4,16.411 7.589,20 12,20 Z M12,2 C17.514,2 22,6.486 22,12 C22,17.514 17.514,22 12,22 C6.486,22 2,17.514 2,12 C2,6.486 6.486,2 12,2 Z",
    fill: "currentColor"
  })));
};

CloseCircleIcon.defaultProps = {
  width: "24px",
  height: "24px",
  "aria-label": "Close",
  color: "#37506E"
};
var _default = CloseCircleIcon;
exports["default"] = _default;